import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

import { appPublicFetcher } from '@/libs/fetcher/presets'
import { CryptoBasketResponse, YieldProductItem } from '@/types/invest'

export const fetchCryptoBasket = (slug?: string) =>
  appPublicFetcher<CryptoBasketResponse>(
    slug ? `/crypto-baskets/offers?search=${slug}` : `/crypto-baskets/offers`,
  )

export const cryptoBasketQueryOptions = (slug?: string) =>
  queryOptions({
    queryKey: ['cryptoBasket', slug],
    queryFn: () => fetchCryptoBasket(slug),
  })

export const useCryptoBasket = (slug?: string) => useSuspenseQuery(cryptoBasketQueryOptions(slug))

// https://app.3ona.co/api/v1/public/yield-products/all-coins
export const fetchYieldProducts = (slug?: string) =>
  appPublicFetcher<YieldProductItem[]>(
    slug ? `/yield-products/all-coins?currency=${slug}` : `/yield-products/all-coins`,
  )
export const yieldQueryOptions = (slug?: string) =>
  queryOptions({
    queryKey: ['yieldProducts', slug],
    queryFn: () => fetchYieldProducts(slug),
  })

export const useYieldProducts = (slug?: string) => useSuspenseQuery(yieldQueryOptions(slug))
